import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import i18next from 'i18next';
import Popover from '../UserAccount/popover';
import { PrimaryButton } from '../../msreact-kit/html-components/button';
import { logout } from '../../actions/LoginAction';
import { postLoginRedirectPathKey } from '../../utils';
import '../UserAccount/index.scss';

// Reuses the same dropdown (Popover) and styling as the dashboard header's UserAccount menu,
// but shows the loan applicant's own details instead of dashboard company data.
const LoanUserMenu = ({ firstName, lastName, emailId, iconAriaLabel }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  // Falls back to the auth session email until the user has completed loan registration.
  const { authUserEmail } = useSelector((state) => ({
    authUserEmail: state.loginReducer.user?.emailId
  }));

  const handleIconClick = (event) => {
    setAnchorEl(event.currentTarget);
    setIsOpen(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setIsOpen(false);
  };

  const handleSignOut = () => {
    // So the post-login redirect brings the user back to this page instead of the dashboard.
    const { pathname, search = '', hash = '' } = history.location;
    sessionStorage.setItem(postLoginRedirectPathKey, `${pathname}${search}${hash}`);
    dispatch(logout());
  };

  const displayName = [firstName, lastName].filter(Boolean).join(' ');
  const displayEmail = emailId || authUserEmail;

  return (
    <div className='username-block'>
      <i
        className='a-icon boschicon-bosch-ic-my-brand-frame -size-l'
        onClick={handleIconClick}
        tabIndex={0}
        role='button'
        aria-label={iconAriaLabel}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') handleIconClick(event);
        }}
      />
      <Popover isOpen={isOpen} anchorEl={anchorEl} onClose={handleClose}>
        <div className='user-account-details'>
          {displayName && (
            <div className='user-account-usernames -size-m highlight'>
              {displayName}
            </div>
          )}
          {displayEmail && (
            <div className='user-account-email -size-m'>{displayEmail}</div>
          )}
          <PrimaryButton
            label=''
            className='user-account-signout-button'
            onClick={handleSignOut}
          >
            <span>{i18next.t('DYNAMIC_FORM.USER_ACCOUNT.SIGN_OUT')}</span>
            <i className='a-icon boschicon-bosch-ic-logout logout-icon' />
          </PrimaryButton>
        </div>
      </Popover>
    </div>
  );
};

export default LoanUserMenu;
